import Vuex from 'vuex'
import Vue from 'vue'
import favorite from './favorite'
import shop_card from './shop-card'
import catalog from './catalog'
import album from './album'
import search from './search'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    favorite,
    shop_card,
    catalog,
    album,
    search
  },
})
